import { action } from 'mobx'

import AgencyResources from 'Services/AgencyResources'
import BaseStore from 'Stores/base_store/BaseStore'
import { getStoreFor } from 'Stores/StoreInstances'

export const STORE_TYPE = 'EventCategories'

export function getEventCategoriesStoreFor (param, opts = {}) {
  return getStoreFor(EventCategoriesStore, STORE_TYPE, param, {
    forceUnique: false,
    preload: opts.preload,
    autoFetch: opts.autoFetch,
    fetchAll: opts.fetchAll,
  })
}

class EventCategoriesStore extends BaseStore {
  constructor (seedData) {
    const opts = {
      paginate: false,
    }
    super(STORE_TYPE, seedData, opts)
  }

  @action
  // NOTE: this is returning nil when using a BA
  _fetchAll () {
    let payload = {
      ...this._filter,
    }
    return AgencyResources.requestResources(payload)
        .then(resources => resources.event_categories)
        .catch(console.error)
  }
}

export default EventCategoriesStore
